import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComingSoonCta from '@/components/feature/ComingSoonCta';

const tracks = [
  { number: '01', title: 'Comienza la noche', description: 'energía inicial, todavía activa' },
  { number: '02', title: 'Bajando el ritmo', description: 'transición, más lento' },
  { number: '03', title: 'Las luces se apagan', description: 'más silencioso, atenuando' },
  { number: '04', title: 'El silencio que habla', description: 'más espacio entre notas' },
  { number: '05', title: 'La pesadez del sueño', description: 'sensación de párpados pesados' },
  { number: '06', title: 'Entre el sueño y la vigilia', description: 'a medio camino del descanso' },
  { number: '07', title: 'El umbral', description: 'cruzando hacia el sueño' },
  { number: '08', title: 'La profundidad', description: 'sueño profundo, notas mínimas' },
  { number: '09', title: 'Silencio activo', description: 'casi nada, un silencio amplio' },
  { number: '10', title: 'La noche completa', description: 'entrega total, cierre del ritual' },
];

const heroImage = 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20softly%20singing%20to%20her%20baby%20while%20lighting%20a%20gentle%20candle%20in%20a%20dimly%20lit%20warm%20bedroom%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20intimate%20nighttime%20ritual%2C%20mother%20with%20serene%20expression%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20soft%20candlelight%20glow%2C%20sacred%20bedtime%20ritual%2C%20soft%20textures%2C%20baby%20peacefully%20in%20mothers%20arms%2C%20magical%20evening%20atmosphere&width=1400&height=600&seq=275&orientation=landscape';

export default function AlbumRitualNocturno() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Reading Progress Bar */}
      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      {/* Hero Section */}
      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('album_ritual.tag')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('album_ritual.title1')}
                <br />
                <span className="font-bold">{t('album_ritual.title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('album_ritual.hero.desc')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-moon-line text-xs" />
                  {t('album_ritual.badge1')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  {t('album_ritual.badge2')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-music-line text-xs" />
                  {t('album.temas_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-download-cloud-line text-xs" />
                  {t('album.descarga_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('album.uso_badge')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$12.99</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')} — {t('common.pago_unico')}</span>
              </div>
              <ComingSoonCta />
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt="Madre y bebé en ritual nocturno con luz de vela"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Sinopsis */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-moon-clear-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            {t('album_ritual.sinopsis.title')}
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Hay algo que pasa cuando la noche se convierte en ritual. No es solo que el bebé duerma mejor. Es que el día entero adquiere un sentido nuevo. Es que la relación entre mamá y bebé se transforma en algo ceremonial, intencional, sagrado.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Este álbum no es música para dormir. Es la banda sonora de un ritual. Cada pieza está diseñada para acompañar una fase específica del proceso de ir a dormir: el baño, la luz baja, el último contacto, la última voz. Y cuando la música se convierte en señal, el cerebro de tu bebé aprende algo que ninguna técnica puede enseñar: que la noche es un refugio, que el sueño es un ritual, que vos estás ahí.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            No es una lista de canciones. Es una secuencia. Cada tema baja la activación un poco más que el anterior. Cuando termina el último tema, el cerebro de tu bebé ya está listo para dormir. Sin lucha. Sin llanto. Solo música y vos.
          </p>
        </div>
      </section>

      {/* Track List */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('album.lista_temas')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('album_ritual.tracks_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              Cada tema es una fase del ritual. Juntos, forman la secuencia más completa para transformar la noche en un refugio.
            </p>
            <p className="font-sans text-sm text-terracotta font-medium mt-4">
              Este álbum es una secuencia progresiva — está diseñado para escucharse en orden, de principio a fin, como parte del ritual nocturno completo.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-sand/40 overflow-hidden">
            {tracks.map((track, index) => (
              <div
                key={track.number}
                className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 ${index !== tracks.length - 1 ? 'border-b border-sand/20' : ''}`}
              >
                <span className="font-sans text-sm font-medium text-[#5C4A3A] flex-shrink-0 w-8">
                  {track.number}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C]">
                    {track.title}
                  </h3>
                  <p className="font-sans text-sm text-[#5C4A3A] mt-0.5">
                    {track.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cierre emocional */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-moon-clear-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            &ldquo;Este álbum no es una playlist cualquiera — es un viaje de veinte minutos, pensado tema por tema, para acompañar exactamente el momento en que el día se apaga y la noche empieza. Cada canción baja un poco más la intensidad que la anterior, hasta que, sin que nadie lo fuerce, el sueño llega solo. Ponelo siempre en el mismo momento, en el mismo orden. Con el tiempo, tu bebé va a aprender que estas notas significan una sola cosa: ya es hora de descansar, y estás a salvo.&rdquo;
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            — Mercedes, NeuroBabys
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('album_ritual.cta.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('album_ritual.cta.desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$12.99</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <ComingSoonCta size="lg" className="mb-4" />
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('album.descarga_footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}